import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RegistrationPaymentInfo } from 'src/app/interfaces/user';
import { PaymentConfigService } from '../payment-config/payment-config.service';
import { AuthManagerService } from '../auth-manager/auth-manager.service';

@Injectable({ providedIn: 'root' })
export class PaymentConfigResolverService
  implements Resolve<RegistrationPaymentInfo | null>
{
  constructor(
    private paymentConfigService: PaymentConfigService,
    private authManager: AuthManagerService
  ) {}

  resolve(): Observable<RegistrationPaymentInfo | null> {
    // /payment API endpoint is per-user; skip the call on public pages
    // when the visitor is not authenticated.
    return this.authManager.isAuthenticated ? this.paymentConfigService.load() : of(null);
  }
}
